App.factory('base64ToImage', Base64ToImage);

function Base64ToImage() {
    var serviceObj = {};
    serviceObj.set = Set;
    function Set(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        //return new File([u8arr], filename, {type:mime});
        return new Blob([u8arr], {type:mime});
    }

    return serviceObj;
}